<template>
	<section>
        <div id="analyDiv">
            <!--工具条-->
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters"  size="mini">
                    <el-form-item label="项目名称">
                        <el-select v-model="filters.projectId" @change="getDevices" filterable>
                            <el-option
                                v-for="item in projects"
                                :label="item.name"
                                :value="item.projectId" :key="item.projectId">
                            </el-option >
                        </el-select>
                    </el-form-item>
                    <el-form-item label="点位名称" >
                        <el-select v-model="filters.mn" filterable>
                            <el-option
                                v-for="item in devices"
                                :label="item.name"
                                :value="item.mnCode" :key="item.mnCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备编码"  v-if="type==0">
                        <el-select v-model="filters.mn" filterable>
                            <el-option
                                v-for="item in devices"
                                :label="item.mnCode"
                                :value="item.mnCode" :key="item.mnCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间范围">
                        <el-date-picker
                            v-model="filters.time" type="datetimerange" unlink-panels :picker-options="pickerOptions" 
                            range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <my-button  @select-type="clickBtn" QueryButtonShow ExportButtonShow></my-button>
                        <!-- <edit-button  @select-type="getChooseDay"  :disabled="this.sels.length===0" btnCon="剔除"></edit-button> -->
                    </el-form-item>
                </el-form>
            </el-col>

            <el-descriptions title="" :column="4" border>
                <el-descriptions-item label="总开始时间">{{analyObj.starttime}}</el-descriptions-item>
                <el-descriptions-item label="总结束时间">{{analyObj.endtime}}</el-descriptions-item>
                <el-descriptions-item label="Lwecpn" span="2" >{{analyObj.lwecpn}}dB</el-descriptions-item>

                <el-descriptions-item label="总飞行次数" >{{analyObj.allsum}}</el-descriptions-item>
                <el-descriptions-item label="白天的飞行次数" >{{analyObj.btsum}}</el-descriptions-item>
                <el-descriptions-item label="傍晚的飞行次数" >{{analyObj.bwsum}}</el-descriptions-item>
                <el-descriptions-item label="夜间的飞行次数" >{{analyObj.yjsum}}</el-descriptions-item>
            </el-descriptions>
        </div>
        
        <div style="margin-top: 20px;">
            <el-table :data="dataPageList" border highlight-current-row v-loading="listLoading" style="width: 100%;" 
                :height="formHeight"  @selection-change="selsChange"  size="small" >
                <!-- <el-table-column   type="selection"   width="55">   </el-table-column> -->
                <el-table-column type="index" label="序号"  ></el-table-column>
                <el-table-column prop="startTime" label="开始时间"  ></el-table-column>
                <el-table-column prop="endTime" label="结束时间" ></el-table-column>
                <el-table-column prop="lepn" label="Lepn(dB)" ></el-table-column>
                <el-table-column prop="td" label="持续时间(s)" ></el-table-column>
                <el-table-column prop="lmax" label="Lmax(dB)" ></el-table-column>

                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <table-query-button   @select-type="showDetail(scope.$index, scope.row)" btnCon="数据详情">  </table-query-button>
                    </template>
                </el-table-column>
                
            </el-table>

            <!--工具条-->
            <el-col :span="24" class="toolbar">
                <el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[ 50, 100, 200,500]"   @size-change="handleSizeChange" :current-page.sync="page">
                </el-pagination>
            </el-col>

           
            <el-dialog  title="秒数据详情" :visible.sync="secondVisible" :close-on-click-modal="true">
                <div id="secondLine" v-loading="secondLoading"></div>
            </el-dialog>
        </div>

	</section>
</template>

<script>
	import { getProjects,getDevicesByProjectId,selectData,selectSecondData} from '../../api/api';
	import {formatDate} from '../../../static/fun.js';

	import FormQueryButton from '../../components/myButton/FormQueryButton.vue'
	import EditButton from '../../components/myButton/EditButton.vue'
    import TableQueryButton from '../../components/myButton/TableQueryButton.vue'
    import myButton from '../../components/myButton/index.vue'

    import * as echarts from "echarts";

	export default {
	components: { FormQueryButton ,EditButton,TableQueryButton,myButton},
		data() {
			return {
				pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				filters: {
					projectId:"",
					mn:"",
					time:[]
				},
				total: 0,
				page:1,
				pageSize:50,
				listLoading: false,
                listhourLoading:false,
				dataList:[],
                dataPageList:[],
				firstFlag:true,
				devices:[],
				projects:[],
				formHeight:0,

				type:sessionStorage.getItem("type"),
                sels:[],

                analyObj:{
                    starttime:'',
                    endtime:'',
                    allsum:'',
                    btsum:'',
                    yjsum:'',
                    bwsum:'',
                    lwecpn:''
                },

                secondVisible:false,
                secondLoading:false,
                secondLine:null,
                choosemn:""
			}
			
		},
		methods: {
            showDetail(i,row){
                this.secondVisible=true;
                this.secondLoading=true;

                var para={
                    mn:this.choosemn,
                    startTime:row.startTime,
                    endTime:row.endTime
                }
                selectSecondData(para).then((res) => {
                    this.secondLoading = false;
                    if(res.data.result=="false"||res.data.result==false){
                        this.$message({
                            message: "查询失败，请重试",
                            type: 'error'
                        })
                    }else{
                        this.drawLineChart(res.data.datas);
                    }
                }).catch(() => {
                    this.secondLoading = false;
                });
            },
            drawLineChart:function(sourceData) {
                document.getElementById("secondLine").style.height=this.formHeight*0.7+"px";
                this.secondLine = echarts.init(document.getElementById('secondLine'));

                this.secondLine.setOption({
                    title: {
                        text: '数据趋势图',
                        x:'center'
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: function(params) {
                            var result = params[0].name+'<br>';
                            params.forEach(function(item) {
                                result +=item.seriesName+" : "+'<span style="display:inline-block;min-width:80px">'+ item.data[item.seriesName]+"</span><br>"
                            });
                            return result;
                        },
                    },
                    toolbox: {
                        show : true,
                        feature: {
                            dataZoom: {
                                yAxisIndex:"none"
                            },
                            magicType: {show: true, type: ['line', 'bar']},
                            saveAsImage: {
                                show:true,
                                excludeComponents :['toolbox'],
                                pixelRatio: 2
                            }
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        top:60,
                        containLabel: true
                    },
                    dataset: {
                        dimensions: ['time', 'leq'],
                        source: sourceData
                    },
                    xAxis: [{
                        boundaryGap: true,
                        name:'时间',
                        type: 'category'
                    }],
                    yAxis: [{
                        type: 'value',
                        name:'数值',
                        scale:true
                    }],
                    series: [{
                        type: 'line'
                    }]
                },true);
            },
            clickBtn(type){
				if(type=="query"){
                    this.getDataList(1);
				}else if(type=="export"){
                    this.exportData();
				}
			},
            exportData(){
                require.ensure([], () => {

                    let sheetName1 = "总体概况"; 
                    let tHeader1 = ['总开始时间','总结束时间','Lwecpn','总飞行次数','白天的飞行次数','傍晚的飞行次数','夜间的飞行次数'];  
                    var data1=[this.analyObj.starttime,this.analyObj.endtime,this.analyObj.lwecpn+'dB',this.analyObj.allsum,this.analyObj.btsum,this.analyObj.bwsum,this.analyObj.yjsum];
					
                    let sheetName2 = "飞行事件列表"; 
                    let tHeader2=['开始时间','结束时间','Lepn(dB)','持续时间(s)','Lmax(dB)'];
                    var data2=[];
                    const filterVal = ['startTime', 'endTime', 'lepn','td','lmax'];  
                    data2.push(this.formatJson(filterVal, this.dataList));

                    const { export_json_to_excel_Flight } = require('vendor/Export2Excel');
                    export_json_to_excel_Flight(tHeader1,tHeader2,data1,data2, '飞行事件记录表',sheetName1,sheetName2);

                }) 
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            }, 
            getChooseDay(){
                var ids = this.sels.map(item => item.id).toString();
                console.log("剔除数据，并进行数据重算")
                this.analyObj.allsum++;
            },
            selsChange: function (sels) {
				this.sels = sels;
			},
			handleCurrentChange(val) {
				this.page=val;
                this.paginatedData();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.page=1;
                this.paginatedData();
			},
            paginatedData() {
                const start = (this.page - 1) * this.pageSize;
                const end = start + this.pageSize;
                this.dataPageList=this.dataList.slice(start, end);
            },
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					//如果当前已选的设备不属于选中的项目，把设备置空
					var flag=false;
					if(this.filters.deviceId!=""){
						this.devices.forEach(item => {
							if(item.mnCode==this.filters.mn){
								flag=true;
							}
						});		
					}
					if(!flag&&this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
					}
					if(this.firstFlag){
						this.firstFlag=false;
						this.getDataList(1);
					}
				});
            },
			//获取历史数据信息
			getDataList(type){
                this.page=1;
				var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
                }
				let para = {
					pageNum: this.page,
					pageSize:this.pageSize,
                    mn: this.filters.mn,
					startTime: starttime,
                    endTime: endtime
				};
				if(this.filters.mn==""){
					this.$message({
						message: "未选择设备",
						type: 'warning'
					})
					return;
				}
				this.listLoading = true;
				selectData(para).then((res) => {
					this.listLoading = false;
                    if(res.data.code!=200){
                        this.$message({
                            message: "查询失败，请重试",
                            type: 'error'
                        })
						return;
                    }

                    this.total=res.data.data.noiseAirportDataList.length;

                    this.dataList=res.data.data.noiseAirportDataList;
                    this.choosemn=para.mn;
                    
                    this.analyObj.starttime=para.startTime;
                    this.analyObj.endtime=para.endTime;
                    this.analyObj.allsum=this.total;

                    //剩余参数待确定 lwepn  各种次数
                    this.analyObj.lwecpn=res.data.data.Lwecpn;
                    this.analyObj.btsum=res.data.data.dayTimeTotal;
                    this.analyObj.yjsum=res.data.data.nightTimeTotal;
                    this.analyObj.bwsum=res.data.data.duskTimeTotal;

                    this.paginatedData();
				});
			},
			
		
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementById('analyDiv').clientHeight ;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			},
			setTime(){
				var end = new Date();
				var start = new Date();
                start.setTime(start.setDate(start.getDate()-1));
				this.filters.time= [formatDate(start), formatDate(end)];
				this.getProjects();
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			
			this.setTime();
		},
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// FlightEvent.vue?31a7efaf